// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"15f98b5f","453":"fad0acb2","780":"d374dd17"}[chunkId] + ".chunk.js";
};